const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/login",
    meta: {
        public: true
    },
    name: "login",
    component: () => import("../views/SignIn.vue")
});

/*** PRIVATE RULES */
Routes.push(
    {
        path: "/",
        meta: {},
        name: "home",
        component: () => import("../views/Home.vue")
    },
    {
        path: "/products",
        meta: {},
        name: "products",
        component: () => import("../app/Users.vue")
    },
    {
        path: "/level-events",
        meta: {},
        name: "LevelEvents",
        component: () => import("../app/LevelEvents.vue")
    },
    {
        path: "/game-item-events",
        meta: {},
        name: "GameItemEvents",
        component: () => import("../app/GameItemEvents.vue")
    },
    {
        path: "/shop-item-events",
        meta: {},
        name: "ShopItemEvents",
        component: () => import("../app/ShopItemEvents.vue")
    },
    {
        path: "/user-events",
        meta: {},
        name: "UserEvents",
        component: () => import("../app/UserEvents.vue")
    },
    {
        path: "/level-progress",
        meta: {},
        name: "LevelProgress",
        component: () => import("../app/LevelProgress.vue")
    },
    {
        path: "/user-log",
        meta: {},
        name: "UserLog",
        component: () => import("../app/UserLog.vue")
    },
    {
        path: "/level-progress-events",
        meta: {},
        name: "LevelProgressEvents",
        component: () => import("../app/LevelProgressEvents.vue")
    }
);

/*** SYSTEM RULES */
Routes.push(
    {
        path: "*",
        meta: {
            public: true
        },
        redirect: {
            path: "/404"
        }
    },
    {
        path: "/404",
        meta: {
            public: true
        },
        name: "NotFound",
        component: () => import("~/views/system/NotFound.vue")
    },
    {
        path: "/403",
        meta: {
            public: true
        },
        name: "AccessDenied",
        component: () => import("~/views/system/Deny.vue")
    },
    {
        path: "/500",
        meta: {
            public: true
        },
        name: "ServerError",
        component: () => import("~/views/system/Error.vue")
    }
);

export default Routes;